import React from 'react';

export default function UserStatus(props) {
    return (
        <div className={"userStatus " + ((props.status) ? 'active' : 'away')}>
            <svg height="10" width="10">
                <circle cx="5" cy="5" r="5" fill={ props.status ? '#06B07D' : '#FF6666' } />
            </svg> 
            <p><span className="username">{ props.name.toUpperCase() }</span></p>
        </div>
    );
}